import React from 'react'

import { FemiSubscriptions } from 'modules/femiUnsubscribe/components/FemiSubscriptions'

import { AppName } from 'root-constants'

type TSubscriptionsTabProps = {
  onRequestWithdrawal: (subscriptionId: string, contract: string) => void
}

export const APP_SUBSCRIPTIONS_TABS: Partial<
  Record<AppName, React.FC<TSubscriptionsTabProps>>
> = {
  [AppName.FEMI]: FemiSubscriptions,
}
